import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { Marker, Popup } from "react-leaflet";
import { IconFtteMarker } from "../icons";

import { Immeuble } from "../../../../services";
import { setLogoFromDsp } from "../../../../utils";

const MarkersImbFtteVN = ({ dsp, imbWkt, setChargementIMBWtk, enqueueSnackbar }) => {
  const [markersFTTE, setMarkersFTTE] = useState([]);
  const [abortImbFtteWkt, setAbortImbFtteWkt] = useState(new AbortController());

  // Récupère les immeubles FTTE pour une zone géographique
  const getImmeublesFtteWkt = async (minLatLng, maxLatLng) => {
    setChargementIMBWtk(true);

    abortImbFtteWkt.abort();
    const abort = new AbortController();
    setAbortImbFtteWkt(abort);

    /*  Récupère l'adresse MUX altitude pour récupérer les infos immeubles de la zone */
    Immeuble.getImmeublesVendeeFtteWkt(
      minLatLng.lng,
      minLatLng.lat,
      maxLatLng.lng,
      maxLatLng.lat,
      abort,
    )
      .then(responseImbsFtte => {
        const markersFtteTemp = responseImbsFtte.features
          .filter(imb => imb.properties.codeReseau === dsp.codeReseau)
          .map(item => {
            const statutElig = item.properties.statutPBFTTE
              ? item.properties.statutPBFTTE
              : "en attente";

            const marker = {
              key: item.properties.referenceIMB,
              position: [item.geometry.coordinates[1], item.geometry.coordinates[0]],
              icon: IconFtteMarker,
              referenceIMB: item.properties.referenceIMB,
              statutElig: statutElig,
              nomBatiment: item.properties.nomBatiment,
              numeroAdresse: item.properties.numeroAdresse,
              voieAdresse: item.properties.voieAdresse,
              codePostal: item.properties.codePostal,
              libelleCommune: item.properties.libelleCommune,
            };

            return marker;
          });

        setMarkersFTTE(markersFtteTemp);
        setChargementIMBWtk(false);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          setChargementIMBWtk(false);
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  useEffect(() => {
    if (imbWkt.minLatLng && imbWkt.maxLatLng) {
      getImmeublesFtteWkt(imbWkt.minLatLng, imbWkt.maxLatLng);
    }

    return () => abortImbFtteWkt.abort();
  }, [imbWkt]);

  useEffect(() => () => abortImbFtteWkt.abort(), []);

  return (
    <>
      {markersFTTE.length > 0 &&
        markersFTTE.map(marker => (
          <Marker
            key={marker.key}
            position={marker.position}
            icon={marker.icon}
            statutElig={marker.statutElig}
            riseOnHover
          >
            <Popup maxWidth={260} autoPan={false}>
              <div className="alignRight">{setLogoFromDsp(dsp)}</div>
              <div>
                <span className="popupTitle popupTitleColor">{marker.referenceIMB}</span>
              </div>
              {marker.nomBatiment && <div>{marker.nomBatiment}</div>}
              <div>
                {marker.numeroAdresse} {marker.voieAdresse} {marker.codePostal}{" "}
                {marker.libelleCommune}
              </div>
              <br />
              <div>Eligibilité : {marker.statutElig}</div>
              <br />
              <div>
                Votre bâti est éligible à une offre de{" "}
                <a
                  href="https://www.vendeenumerique.fr/la-fibre/la-fibre-ftte/"
                  target="_blank"
                  rel="noreferrer"
                >
                  fibre pro FttE.
                </a>
                <br />
                Pour toute demande de raccordement, contactez{" "}
                <a
                  href="https://www.vendeenumerique.fr/operateurs-FttE/"
                  target="_blank"
                  rel="noreferrer"
                >
                  un fournisseur d&apos;accès à internet.
                </a>
              </div>
            </Popup>
          </Marker>
        ))}
    </>
  );
};

MarkersImbFtteVN.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
  }).isRequired,
  imbWkt: propTypes.shape({
    minLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
    maxLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
  }).isRequired,
  setChargementIMBWtk: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(MarkersImbFtteVN);
